'use strict';
module.exports = require('./RadioButton.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/radiobutton/index.js
// module id = 774
// module chunks = 7